<template>
  <section class="" :style="{ background: props.backgroundColor }">
    <div class="px-4 py-6 mx-auto max-w-5xl lg:py-10">
    <h4 class="text-lg text-center sm:text-xl lg:text-22 font-ww-bold text-lifeboost-gray-lighter">
        {{ props.title }}
    </h4>

    <div class="mt-2 text-xs text-center sm:text-sm lg:text-base font-ww-regular text-lifeboost-gray-lighter">
        {{ props.description }}
    </div>

</div>
  </section>
</template>

<script setup>
// Props
const props = defineProps({
  title: {
    type: String,
    default: 'FDA Warning'
  },
  description: {
    type: String,
    default: '*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease.'
  },
  backgroundColor: {
    type: String,
    default: '#EBDFD3'
  }
})

defineBuilderComponent({
    friendlyName: 'Title Info Small',
    inputs: [
      {
        name: 'title',
        type: 'text',
        defaultValue: 'FDA Warning'
      },
      {
        name: 'description',
        type: 'longText',
        defaultValue: '*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease.'
      },
      {
        name: 'backgroundColor',
        type: 'color',
        defaultValue: '#EBDFD3'
      }
    ]
})
</script>